import { gql } from '@apollo/client'

export const GET_INVITED_LIST = gql`
    query InvitedList($guid: String!, $limit: Int!, $offset: Int, $q: String) {
        entity(guid: $guid) {
            guid
            ... on Event {
                attendees(
                    limit: $limit
                    offset: $offset
                    query: $q
                    orderBy: timeUpdated
                    orderDirection: desc
                    isInvited: true
                    state: "unconfirmed"
                ) {
                    total
                    edges {
                        guid
                        icon
                        url
                        name
                        email
                    }
                }
            }
        }
    }
`
